import Guard from 'arg-guard'
import { FEATURES } from './scheme-config'

/**
 * Default features and the enabled state.
 * @type {Object}
 */
const DEFAULT_FEATURES = {
    [FEATURES.SHOPPING_BASKET]: false,
}

/**
 * A definition of supported features for a scheme under a specific domain name.
 * @description When using the local urls, suffix with `:8080`
 * @example: new SchemeHost('local-ecofurb-pb.localhost:8080')
 * @class SchemeHost
 */
export default class SchemeHost {
    /**
     * Defines a SchemeHost
     * @param {string} host The root host domain
     * @param {Object} [features=DEFAULT_FEATURES]
     */
    constructor(host, features = DEFAULT_FEATURES) {
        Guard.throwIf(host, 'host')

        /**
         * @type {string}
         */
        this.host = host

        /**
         * @type {Object}
         */
        this.features = features
    }

    /**
     * Return true if the scheme host has the requested feature.
     * @param {string} feature
     * @returns {boolean}
     * @example schemeHost.hasFeature(FEATURE.SHOPPING_BASKET)
     */
    hasFeature(feature) {
        Guard.throwIf(feature, 'feature')

        return this.features[feature] || false
    }
}
